import React from 'react'
import styled, { css } from 'styled-components'
import ButtonShell from 'components/elements/Buttons/ButtonShell'

export const ButtonPrimaryCSS = css`
  position: relative;
  display: inline-block;
  transition: 0.65s ease-out;
  overflow: hidden;
  background-color: ${({ theme }) => theme.color.primary};

  & > a,
  & > button {
    position: relative;
    z-index: 2;
    color: ${(props) => props.theme.color.light} !important;
    font-family: ${({ theme }) => theme.font.family.primaryMedium};
    padding: 10px 15px;
    width: 100%;
    height: 100%;
    display: block;
    text-decoration: none !important;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 130%;
    height: 100%;
    background: ${({ theme }) => theme.color.dark};
    transform-origin: 0 0;
    transform: translateX(-100%) skewX(-45deg);
    transition: transform 0.65s;
  }

  &:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.color.light} !important;
    &:before {
      transform: translateX(0) skewX(-45deg);
    }
  }
`

const StyledButton = styled.span`
  ${ButtonPrimaryCSS};
`

interface ButtonPrimaryProps {
  isAnchor?: boolean
  isCustom?: boolean
  to: string
  className?: string
  target?: string
}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  isAnchor = false,
  isCustom = false,
  to,
  children,
  className = '',
  target = '',
}) => (
  <StyledButton className={className}>
    {isCustom ? (
      children
    ) : (
      <ButtonShell to={to} isAnchor={isAnchor} target={target}>
        {children}
      </ButtonShell>
    )}
  </StyledButton>
)

export default ButtonPrimary
